<template>
  <div>
    <Head>
      <title>{{ __($page.props.title) }}</title>
    </Head>

    <NotificationOverlay/>

    <!--    <page-loader/>-->
    <div :class="backgroundClass">
      <div class="absolute inset-0 hidden lg:block" aria-hidden="true">
        <slot name="top"/>
        <!--            <svg class="absolute inset-y-0 transform translate-x-1/4" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">-->
        <!--                <path fill="#141A26" d="M43.5,-75.3C56.4,-67.9,67,-56.3,75,-43.1C83,-29.8,88.5,-14.9,88.6,0C88.6,14.9,83.1,29.9,75.4,43.7C67.7,57.5,57.8,70.2,44.8,78.3C31.9,86.4,15.9,89.9,0.3,89.3C-15.2,88.7,-30.5,84,-43.6,75.9C-56.6,67.9,-67.5,56.6,-75.5,43.4C-83.5,30.2,-88.6,15.1,-88.4,0.2C-88.1,-14.8,-82.4,-29.5,-74.1,-42.3C-65.9,-55,-55,-65.7,-42.2,-73.1C-29.4,-80.6,-14.7,-84.9,0.3,-85.4C15.3,-86,30.6,-82.8,43.5,-75.3Z" transform="translate(100 100)" />-->
        <!--            </svg>-->
        <!--            <svg class="absolute bottom-0 right-0 transform translate-x-1/2 mb-48 text-gray-700 lg:top-0 lg:mt-28 lg:mb-0 xl:transform-none xl:translate-x-0" width="364" height="384" viewBox="0 0 364 384" fill="none">-->
        <!--                <defs>-->
        <!--                    <pattern id="eab71dd9-9d7a-47bd-8044-256344ee00d0" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">-->
        <!--                        <rect x="0" y="0" width="4" height="4" fill="currentColor" />-->
        <!--                    </pattern>-->
        <!--                </defs>-->
        <!--                <rect width="364" height="384" fill="url(#eab71dd9-9d7a-47bd-8044-256344ee00d0)" />-->
        <!--            </svg>-->
      </div>
      <div class="relative scrollbar scrollbar-thumb-gray-900 scrollbar-track-gray-100 scrollbar-medium"
           :class="{'pt-6': !poperAbsolute}">
        <Popover :class="{'absolute inset-x-0 top-0 z-50': poperAbsolute}">
          <nav class="relative max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6"
               :class="{'pt-6': poperAbsolute}" aria-label="Global">
            <div class="flex items-center flex-1">
              <div class="flex items-center justify-between w-full md:w-auto">
                <inertia-link href="/">
                  <span class="sr-only">LIVCK</span>
                  <img v-if="colorScheme === 'dark'" class="h-8 w-auto sm:h-10"
                       :src="asset('build/brand/wordmark-light.svg')" alt=""/>
                  <img v-else class="h-8 w-auto sm:h-10" :src="asset('build/brand/wordmark.svg')" alt=""/>
                </inertia-link>
                <div class="-mr-2 flex items-center md:hidden">
                  <PopoverButton
                      :class="{'text-gray-400 hover:border-gray-400 border-gray-300': colorScheme == 'light', 'text-gray-400 hover:border-gray-800 border-gray-700': colorScheme == 'dark'}"
                      class="border transition-colors duration-300 ease-in-out rounded-md p-2 inline-flex items-center justify-center focus:outline-none focus:ring-2 focus-ring-inset focus:ring-current">
                    <span class="sr-only">Open main menu</span>
                    <MenuIcon class="h-6 w-6" aria-hidden="true"/>
                  </PopoverButton>
                </div>
              </div>
              <div class="hidden space-x-10 md:flex md:ml-10">
                <inertia-link v-for="item in navigation" :key="item.name" :href="route(item.href)"
                              :class="{'font-medium text-white hover:text-gray-300': colorScheme === 'dark', 'font-medium text-gray-900 hover:text-gray-500': colorScheme === 'light', 'navlink-active': route().current(item.href)}">
                  {{ __(item.name) }}
                </inertia-link>
                <Popover v-slot="{ open }" class="relative">
                  <PopoverButton
                      class="font-medium focus:outline-none"
                      :class="{'text-white hover:text-gray-300': colorScheme === 'dark', 'text-gray-900 hover:text-gray-500': colorScheme === 'light', 'navlink-active text-gray-300': (open || isFeaturesPage()) && colorScheme === 'dark', 'navlink-active text-gray-500': (open || isFeaturesPage()) && colorScheme === 'light'}"
                  >
                    <span>{{ __('Features') }}</span>
                  </PopoverButton>

                  <transition
                      enter-active-class="transition duration-200 ease-out"
                      enter-from-class="translate-y-1 opacity-0"
                      enter-to-class="translate-y-0 opacity-100"
                      leave-active-class="transition duration-150 ease-in"
                      leave-from-class="translate-y-0 opacity-100"
                      leave-to-class="translate-y-1 opacity-0"
                  >
                    <PopoverPanel
                        class="absolute left-1/2 z-10 mt-5 w-screen max-w-sm -translate-x-1/2 transform px-4 sm:px-0 lg:max-w-3xl"
                    >
                      <div
                          class="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5"
                      >
                        <div class="relative grid gap-8 bg-white p-7 lg:grid-cols-2">
                          <inertia-link
                              v-motion
                              :initial="{ y: -100, opacity: 0 }"
                              :enter="{ y: 0, opacity: 1 }"
                              :delay="(iX+1)*5"
                              v-for="(item, iX) in productFeatures"
                              :key="item.name"
                              :href="item.href"
                              class="-m-3 flex items-center rounded-lg p-2 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus-visible:ring focus-visible:ring-primary-500 focus-visible:ring-opacity-50"
                          >
                            <div
                                class="flex h-10 w-10 shrink-0 items-center justify-center text-white sm:h-12 sm:w-12 bg-primary-500/10 text-primary-500 rounded-md p-2.5"
                            >
                              <component :is="item.icon" aria-hidden="true"/>
                            </div>
                            <div class="ml-4">
                              <p class="text-sm font-medium text-gray-900">
                                {{ __(item.name) }}
                              </p>
                              <p class="text-sm text-gray-500">
                                {{ __(item.description) }}
                              </p>
                            </div>
                          </inertia-link>
                        </div>
                        <div class="bg-gray-50 p-4">
                          <a
                              href="https://help.livck.com"
                              target="_blank"
                              class="flow-root rounded-md px-2 py-2 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus-visible:ring focus-visible:ring-primary-500 focus-visible:ring-opacity-50"
                          >
                          <span class="flex items-center">
                            <span class="text-sm font-medium text-gray-900">
                              {{ __('Documentation') }}
                            </span>
                          </span>
                            <span class="block text-sm text-gray-500">
                            {{ __('Learn more about how livck works') }}
                          </span>
                          </a>
                        </div>
                      </div>
                    </PopoverPanel>
                  </transition>
                </Popover>
              </div>
            </div>
            <div class="hidden md:flex items-center space-x-4">
              <inertia-link v-if="!$page.props.user?.id" :href="route('register')" class="text-sm font-medium"
                            :class="{'text-gray-600 hover:text-gray-900': colorScheme == 'light', 'text-white hover:text-gray-300': colorScheme == 'dark'}">
                {{ __('Sign Up') }}
              </inertia-link>
              <inertia-link :href="route('login')"
                            class="inline-flex space-x-2 items-center px-4 py-2 text-sm font-medium rounded-md text-white bg-primary hover:bg-primary-600">
                <component v-if="$page.props.user?.id" :is="userIcon" class="h-5 w-5 text-gray-100" aria-hidden="true"/>
                <div>{{ $page.props.user?.id ? $page.props.user.fullName : __('Sign In') }}</div>
                <component v-if="!$page.props.user?.id" :is="signIn" class="h-5 w-5 text-gray-100" aria-hidden="true"/>
              </inertia-link>
            </div>
          </nav>

          <transition enter-active-class="duration-150 ease-out" enter-from-class="opacity-0 scale-95"
                      enter-to-class="opacity-100 scale-100" leave-active-class="duration-100 ease-in"
                      leave-from-class="opacity-100 scale-100" leave-to-class="opacity-0 scale-95">
            <PopoverPanel focus
                          class="absolute z-10 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
              <div class="rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden">
                <div class="px-5 pt-4 flex items-center justify-between">
                  <div>
                    <img class="h-8 w-auto" :src="asset('build/brand/wordmark.svg')" alt=""/>
                  </div>
                  <div class="-mr-2">
                    <PopoverButton
                        class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500">
                      <span class="sr-only">Close menu</span>
                      <XIcon class="h-6 w-6" aria-hidden="true"/>
                    </PopoverButton>
                  </div>
                </div>
                <hr class="divider my-4">
                <div class="px-2 pt-2 pb-3 space-y-1">
                  <inertia-link v-for="item in navigation" :key="item.name" :href="route(item.href)"
                                class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50">
                    {{ __(item.name) }}
                  </inertia-link>
<!--                  <inertia-link-->
<!--                      v-for="item in productFeatures"-->
<!--                      :href="item.href"-->
<!--                      class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"-->
<!--                  >-->
<!--                    {{ __(item.name) }}-->
<!--                  </inertia-link>-->
                </div>
                <inertia-link :href="route('login')"
                              class="block w-full px-5 py-3 text-center font-medium text-white bg-primary hover:bg-primary-600">
                  {{ __('Log In') }}
                </inertia-link>
              </div>
            </PopoverPanel>
          </transition>
        </Popover>

        <slot/>

        <x-footer v-if="footer"/>
      </div>

      <cookie-consent v-if="!route().current('policy.show') && !route().current('imprint.show') && !route().current('terms.show')"/>
    </div>
  </div>

</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import {Popover, PopoverButton, PopoverPanel} from '@headlessui/vue'
import {MenuIcon, XIcon} from '@heroicons/vue/outline'
import {ChevronRightIcon} from '@heroicons/vue/solid'
import XFooter from "@/Layouts/Guest/Footer";
import {defineComponent, h} from "vue";

const navigation = [
  {name: 'Pricing', href: 'pricing'},
  {name: 'Statuspage', href: 'statuspage'},
]

const activeLink = defineComponent({
  render: () => h('svg', {fill: 'currentColor', viewBox: '0 0 8.8 2.58'}, [
    h('path', {
      d: 'M.73,3a4.69,4.69,0,0,1,.8-.42A12.25,12.25,0,0,1,7.87,1.38,2.86,2.86,0,0,1,9,1.71',
    }),
  ]),
});

const signIn = defineComponent({
  render() {
    return h('svg', {
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg'
    }, [
      h('path', {
        d: 'M6 17C6 17.3513 6 17.5269 6.01567 17.6796C6.14575 18.9474 7.0626 19.9946 8.30206 20.2911C8.45134 20.3268 8.6255 20.35 8.97368 20.3965L15.5656 21.2754C17.442 21.5256 18.3803 21.6507 19.1084 21.3611C19.7478 21.1069 20.2803 20.6407 20.6168 20.0406C21 19.357 21 18.4105 21 16.5175V7.48244C21 5.5894 21 4.64288 20.6168 3.95935C20.2803 3.35923 19.7478 2.893 19.1084 2.6388C18.3803 2.34926 17.442 2.47435 15.5656 2.72455L8.97368 3.60347C8.62546 3.6499 8.45135 3.67311 8.30206 3.70883C7.0626 4.00532 6.14575 5.05254 6.01567 6.3203C6 6.47301 6 6.64866 6 6.99996M12 7.99996L16 12M16 12L12 16M16 12H3',
        stroke: 'currentColor',
        'stroke-width': '2',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
      })
    ]);
  }
});

const userIcon = defineComponent({
  render() {
    return h('svg', {
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg'
    }, [
      h('path', {
        d: 'M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z',
        stroke: 'currentColor',
        'stroke-width': '2',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
      })
    ]);
  }
})

import productFeatures from "@/data/productFeatures";
import CookieConsent from "@/Misc/CookieConsent";
import PageLoader from "@/Layouts/Misc/PageLoader";
import NotificationOverlay from "@/Misc/NotificationOverlay";

export default {
  name: "GuestLayout",
  props: {
    backgroundClass: {
      default: 'bg-gray-900',
    },
    colorScheme: {
      default: 'dark',
    },
    poperAbsolute: {
      default: false,
    },
    footer: {
      default: true,
    },
  },
  components: {
    NotificationOverlay,
    PageLoader,
    CookieConsent,
    XFooter,
    Popover,
    PopoverButton,
    PopoverPanel,
    ChevronRightIcon,
    MenuIcon,
    XIcon,
    Head,
  },
  methods: {
    isFeaturesPage() {
      var hrefs = this.productFeatures.map((item) => item.href.split('/').pop());
      return hrefs.includes(location.href.split('/').pop());
    },
  },
  setup() {
    return {
      navigation, activeLink, productFeatures, signIn, userIcon,
    }
  },
}
</script>
